var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWfh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0662 17.0971C20.2412 17.5407 20.2412 17.9852 19.9787 18.3396C19.718 18.6948 19.3688 18.9608 18.8456 18.9608H1.84259C1.40684 18.9608 0.970214 18.6948 0.709464 18.3396C0.446964 17.9852 0.446964 17.4523 0.621964 17.0971L2.45334 13.0117H18.1482L20.0662 17.0971Z",
    stroke: "#636980",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0307 16.3375H11.6557M18.15 13.0125V1.8125C18.15 1.1125 17.5392 0.5 16.8418 0.5H3.7632C3.06583 0.5 2.45508 1.1125 2.45508 1.8125V13.0125H18.15Z",
    stroke: "#636980",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4934 10.3859C12.7059 9.51094 11.5684 8.89844 10.3434 8.89844C9.11836 8.89844 7.98086 9.42344 7.19336 10.3859M10.3434 8.46094C10.6881 8.46094 11.0294 8.39304 11.3479 8.26112C11.6664 8.1292 11.9558 7.93585 12.1995 7.69209C12.4433 7.44834 12.6366 7.15896 12.7685 6.84048C12.9005 6.522 12.9684 6.18066 12.9684 5.83594C12.9684 5.49122 12.9005 5.14987 12.7685 4.83139C12.6366 4.51291 12.4433 4.22354 12.1995 3.97978C11.9558 3.73603 11.6664 3.54267 11.3479 3.41075C11.0294 3.27883 10.6881 3.21094 10.3434 3.21094C9.64717 3.21094 8.97949 3.4875 8.4872 3.97978C7.99492 4.47206 7.71836 5.13974 7.71836 5.83594C7.71836 6.53213 7.99492 7.19981 8.4872 7.69209C8.97949 8.18438 9.64717 8.46094 10.3434 8.46094Z",
    stroke: "#636980",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWfh);
export default __webpack_public_path__ + "static/media/wfh.2835fe7a183deaf76387e631a6028ec0.svg";
export { ForwardRef as ReactComponent };